import {useCallback, useRef} from 'react';

export const useAutoButtonClick = () => {
    const buttonRef = useRef<HTMLButtonElement>(null);

    const handleClick = useCallback(() => {
        if (buttonRef.current) {
            buttonRef.current.click();
        }
    }, []);

    return {
        buttonRef,
        handleClick,
    };
};
